import React from 'react';
import classnames from 'classnames';

import { ReactComponent as Arrow } from '../../../images/icon/arrow_carousel.svg';
import styles from './index.module.scss';

interface IProps {
    handelClick?: () => void;
    className?: string;
    type?: string;
    title?: string;
}

const SliderForwardButton: React.FC<IProps> = ({
    handelClick, className, type, title
}): JSX.Element => (
    <>
        {type === 'button' ? (
            <button
                type="button"
                onClick={() => { if (handelClick) { handelClick(); } }}
                className={classnames(className, styles.arrow)}
                title={title}
            >
                <Arrow />
            </button>
        ) : (
            <div className={classnames(className, styles.arrow)}>
                <Arrow />
            </div>
        )}
    </>
);

SliderForwardButton.defaultProps = {
    className: '',
    handelClick: () => null,
    type: 'button',
    title: ''
};

export default SliderForwardButton;
